import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    limpaFiltroDespesasPorEmpenho: [],
    aplicarFiltroDespesasPorEmpenho: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: {},
    unidadeOrcamentaria: {},
    mes: {},
    rubrica: {},
    administracoes: [],
    credor: {},
    orgao: [],
    recursosVinculados: [],
    recursosDestinacao: [],
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.LIMPA_FILTRO_DESPESAS_POR_EMPENHO]: limpaFiltro,
    [Types.APLICAR_FILTRO_DESPESAS_POR_EMPENHO]: aplicarFiltro,
})
